
import { Button } from '@mui/material'

function HeaderMenu( props: HeaderMenuProps ) {
    const { menuDatas } = props

    return (
        <div className="flex mr-1">
            {
                menuDatas.map( menu =>
                    <Button
                        key={ menu.menudId }
                        sx={{
                            fontWeight: '700',
                            fontSize: '17px',
                        }}
                        variant="text"
                        onClick={ menu.onClick }
                    >
                        { menu.menuName }
                    </Button>
                )
            }

        </div>
    )
}

export default HeaderMenu

export interface HeaderMenuProps {
    menuDatas: HeaderMenuData[]
}

type HeaderMenuData = {
    menudId: string
    menuName: string
    onClick: () => void
}